<template>
  <v-img v-if="image" :src="image" width="100%" />
  <v-tooltip v-else top>
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-bind="attrs" v-on="on"> mdi-image-broken-variant </v-icon>
    </template>
    <span>Client did not upload an image with {{ firstLastAssessment }} completed assessment</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "ProgressImageBlock",
  props: ["image", "firstAssessment"],
  computed: {
    firstLastAssessment() {
      return this.firstAssessment ? "first" : "last";
    },
  },
};
</script>
